import { ConfirmModalContent } from "../../../types/common";
import styles from "../../../assets/scss/common/modal/confirmAlertModal.module.scss";
import { ConfirmAlertModal } from "./ConfirmAlertModal";
import React, { useCallback } from "react";
import {useTranslation} from "react-i18next";

interface Props {
    showConfirmModal: boolean;
    closeConfirmModal: (e: React.MouseEvent) => void;
    content: ConfirmModalContent;
}

export function ConfirmModal({ content, showConfirmModal, closeConfirmModal }: Props) {
    const {t} = useTranslation("modal");
    const Buttons = useCallback(
        () => (
            <>
                <button className={styles.cancelBtn} onClick={closeConfirmModal}>
                    {t("cancel")}
                </button>
                <button
                    className={styles.confirmBtn}
                    onClick={(e) => {
                        content.confirmFunc();
                        closeConfirmModal(e);
                    }}
                >
                    {t("confirm")}
                </button>
            </>
        ),
        [content, closeConfirmModal, t]
    );

    return <ConfirmAlertModal showModal={showConfirmModal} content={content.content} buttons={<Buttons />} />;
}
